import 'flickity/dist/flickity.pkgd.min';
require('jquery-match-height');
require('featherlight');
require('featherlight/src/featherlight.gallery.js');
import CCWidgetUtils from '../util/CarbonCureWidgetUtils.js';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { CountUp } from 'countup.js';

window.carboncure = window.carboncure || {};

const ccWidgetUtils = new CCWidgetUtils();
var ccWidgetData = '';
var facetsLoaded = false;
// var map;

// function initMap() {
//   map = new google.maps.Map(document.getElementById('map'), {
//     zoom: 3,
//     center: { lat: -28, lng: 137 },
//   });
//   // NOTE: This uses cross-domain XHR, and may not work on older browsers.
//   map.data.loadGeoJson(
//     '/wp-content/themes/carboncure/resources/json/carboncure_countries.geo.json',
//   );
// }

window.CCAJAX = CCAJAX;
window.get_cookie = get_cookie;
window.set_cookie = set_cookie;
window.get_pref = get_pref;
window.set_pref = set_pref;
window.is_current_location = is_current_location;

function set_cookie(name, value, days) {
  console.log('Setting cookie:', name, value, days);

  var expires = '';
  if (days) {
    var date = new Date();
    date.setTime(date.getTime() + (days*24*60*60*1000));
    expires = '; expires=' + date.toUTCString();
  }
  document.cookie = name + '=' + (value || '')  + expires + '; path=/';
}

$.featherlightGallery.prototype.afterContent = function () {
  var caption = this.$currentTarget.attr('title');
  this.$instance.find('.caption').remove();

  if (caption) {
    $('<div class="caption p-2 small text-center">').text(caption).appendTo(this.$instance.find('.featherlight-content'));
  }
}

function get_cookie(name) {
  console.log('Getting cookie:', name);

  var nameEQ = name + '=';
  var ca = document.cookie.split(';');
  for(var i=0;i < ca.length;i++) {
    var c = ca[i];
    while (c.charAt(0)==' ') c = c.substring(1,c.length);
    if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
  }

  return null;
}

// Cookies stay the source of truth, with localStorage mirroring them so a
// browser that blocks or strips cookie writes still remembers the choice.
// Without this, a failed cookie write means the geo lookup re-runs and
// re-redirects on every single page load.
function set_pref(name, value, days) {
  set_cookie(name, value, days);

  try {
    window.localStorage.setItem(name, value || '');
  } catch (e) {
    // Storage unavailable (private mode / blocked) — cookie only.
  }
}

function get_pref(name) {
  var value = get_cookie(name);

  // An empty string is a deliberate "cleared", so only fall back when the
  // cookie is genuinely absent.
  if (value !== null) return value;

  try {
    return window.localStorage.getItem(name);
  } catch (e) {
    return null;
  }
}

// Never navigate to the page we are already on. This is the guard that makes a
// redirect loop impossible even when every form of storage is unavailable.
function is_current_location(url) {
  if (!url) return true;

  try {
    var target = new URL(url, window.location.href);
    var strip = function(path) { return path.replace(/\/+$/, ''); };

    return target.origin === window.location.origin &&
      strip(target.pathname) === strip(window.location.pathname);
  } catch (e) {
    // Unparseable URL — treat as current so we stay put rather than reload.
    return true;
  }
}

// Circuit breaker: the geo lookup gets one chance per tab, so even if every
// cookie write is discarded the visitor is never bounced more than once.
const geoRedirectFlag = 'site_geo_checked';

function geoRedirectDone() {
  try {
    return window.sessionStorage.getItem(geoRedirectFlag) === '1';
  } catch (e) {
    return false;
  }
}

function markGeoRedirectDone() {
  try {
    window.sessionStorage.setItem(geoRedirectFlag, '1');
  } catch (e) {
    // Storage unavailable — is_current_location() still prevents the loop.
  }
}

//Animate the stats carousel block with number counting.
window.carboncure.count_stats = function() {
  console.log('count stats');
  let stats = document.querySelectorAll('.stat-counter');

  if (stats.length) {
    stats.forEach(stat => {
      const options = {
        duration: 2.5,
        startVal: 0,
        useEasing: false,
      };

      if (stat.getAttribute('data-duration')) {
        options.duration = stat.dataset.duration;
      }

      if (stat.getAttribute('data-decimal')) {
        options.decimalPlaces = stat.dataset.decimal;
      }

      if (stat.getAttribute('data-prefix')) {
        options.prefix = stat.dataset.prefix;
      }

      if (stat.getAttribute('data-suffix')) {
        options.suffix = stat.dataset.suffix;
      }

      var counter = new CountUp(stat, stat.dataset.value, options);
      counter.start();
    });
  }
}

function initialize_carousels() {
  // console.log($('.carousel'));

  if ($('.carousel').length) {
    $('.carousel').each(function() {
      var args = {
        wrapAround: true,
        // watchCSS: true,
        adaptiveHeight: true,
        imagesLoaded: true,
        prevNextButtons: false,
        pageDots: true,
        autoPlay: 7000,
      };

      // Per-carousel overrides, e.g. data-flickity='{"groupCells": true}'.
      $.extend(args, $(this).data('flickity') || {});

      $(this).flickity(args);
    });
  }

  ScrollTrigger.refresh();
}

export default {
  init() {
    // const d = new Date();
    const regionCookie = 'site_region';// + d.getSeconds();
    const continentCookie = 'site_continent';// + d.getSeconds();
    // console.log(CCAJAX);
    // console.warn('Continent Cookie', window.get_cookie(continentCookie));
    // console.warn('Region Cookie', window.get_cookie(regionCookie));

    let regionPicker = document.querySelector('.region-picker');

    if (regionPicker) {
      let region = window.get_pref(regionCookie);
      // console.log('Region Picker Found', region);

      if (region) {
        let option = regionPicker.querySelector('option[data-region="' + region + '"]');

        // The stored region may no longer exist as an option (term renamed or
        // removed), which would otherwise throw and kill the rest of init().
        if (option) {
          option.selected = true;
        }
      }

      regionPicker.addEventListener('change', function() {
        if (regionPicker.value != '') {
          let option = regionPicker.querySelector('option[value="' + regionPicker.value + '"]');

          if (option) {
            window.set_pref(regionCookie, option.dataset.region, 365);
          }

          // A manual choice is final — don't let the geo lookup override it.
          markGeoRedirectDone();

          window.location.href = regionPicker.value;
        }
      });

      if (!window.get_pref(continentCookie) && !geoRedirectDone()) {
        // console.log('No continent cookie');
        markGeoRedirectDone();

        window.set_pref(regionCookie, '', 365);
        window.set_pref(continentCookie, 'NA', 365);

        const requestOptions = {
          method: 'GET',
          redirect: 'follow',
        };

        fetch('https://api.ipgeolocation.io/ipgeo?apiKey=0793f5ad9694428f92f4701657ea8447&fields=continent_code,state_prov', requestOptions)
          .then((response) => response.text())
          .then((result) => {
            result = JSON.parse(result);

            if (!result.continent_code) return;

            let continent = result.continent_code.toUpperCase();

            window.set_pref(continentCookie, continent, 365);

            // some() so the first matching region wins — with forEach, a
            // continent listed on two regions assigned href twice.
            Object.values(CCAJAX.regions).some((match) => {
              if (!match.continents.includes(continent)) return false;

              window.set_pref(regionCookie, match.slug, 365);

              if (!window.is_current_location(match.url)) {
                // console.log('Redirecting to', match.url);
                window.location.href = match.url;
              }

              return true;
            });
          })
          .catch((error) => console.error(error));
      }
    }

    let intro = document.querySelector('.gform-conversational__welcome-message-copy');

    if (intro) {
      intro.innerHTML = intro.textContent.replaceAll('[br]', '<br/>' );
    }

    gsap.registerPlugin(ScrollTrigger);

    var $subscribebar = $('.subscribe-bar');

    if ($subscribebar.length) {
      if (!get_cookie('subscribe_hide')) {
        $subscribebar.on('click', '.close', function(e) {
          // console.log('click');
          // console.log($(this).parent().data('banner-id'));
          set_cookie('subscribe_hide', 'true', 365);
          $subscribebar.slideUp(200);
          $('body').removeClass('sticky-bar-active');
          e.preventDefault();
        });

        $subscribebar.slideDown({
          duration: 200,
          start: function () {
            $(this).css({
              display: 'flex',
            });
          },
        });

        $('body').addClass('sticky-bar-active');
      }
    }

    var $animate_blocks = $('.acf-block.animate');

    if ($animate_blocks.length) {
      $animate_blocks.each(function() {
        ScrollTrigger.batch($animate_blocks.find('.animate-in'), {
          // markers: true,
          // start: 'top bottom',
          // end: 'bottom bottom',
          interval: 0.1,
          batchMax: 5,
          once: true,
          onEnter: elements => gsap.fromTo(elements, {autoAlpha: 0, y: 120}, {autoAlpha: 1, y: 0, ease: 'power3.inOut', stagger: 0.2, duration: 0.7}),
        });
      });
    }

    $(window).on('load', function() {
      initialize_carousels();

      var hash = location.hash.replace('#','');

      if(hash != '' && $('#' + hash).length > 0){
        $('html, body').animate({ scrollTop: $('#' + hash).offset().top - $('.nav-fixed').height()},'slow');
      }

      $('a[target="_blank"]').each(function() {
        $(this).attr('rel', 'noreferer noopener nofollow');
      });

      $('iframe').each(function() {
        $(this).attr('sandbox', 'allow-scripts allow-same-origin allow-popups allow-forms allow-top-navigation');
      });

      ScrollTrigger.refresh();
    }).on('load resize', function() {
      if ($('html').hasClass('nav-open') || $('html').hasClass('modal-open')) {
        $('html').removeClass('modal-open nav-open');
        $('.navbar-toggler').removeClass('active');
        $('#navbarCollapse').slideUp(300).removeClass('show');
      }

      if ($(window).width() < 992) {
        $('header.page-header .nav-fixed .navbar-collapse').css('max-height', 'calc(100vh - ' + $('.announcement-bar').outerHeight() + ')');
      } else {
        $('header.page-header .nav-fixed .navbar-collapse').css('max-height', '');
      }
    });

    //Enable mobile header nav accordion
    $('#menu-main-nav li.dropdown > a').on('click', function(e) {
      e.preventDefault();
      $(this).parent().toggleClass('active');
    });

    //Activate and deactivate the mobile nav hamburger on click.
    $('.navbar-toggler').on('click', function() {
      var topbar_height = $('.navbar-brand').outerHeight();

      if ($('body').hasClass('with-announcement')) {
        topbar_height += $('.announcement-bar').outerHeight();
      }

      if ($('#header_search').hasClass('active') && !$(this).hasClass('active')) {
        $('#header_search').slideToggle().removeClass('active');
      }

      $('.navbar-collapse').css('max-height', 'calc(100vh - ' + topbar_height + 'px)');
      $(this).toggleClass('active');
      $($(this).data('target')).slideToggle(300).toggleClass('show');
      $('html').toggleClass('modal-open nav-open');
    });

    $('[data-toggle="collapse"]').on('click', function(e) {
      e.preventDefault();
      $($(this).attr('data-target')).slideToggle().toggleClass('active');
      $(this).toggleClass('active');

      if ($('html').hasClass('nav-open')) {
        $('.navbar-toggler').trigger('click');
      }
    });

    $('.accordion .item').on('click', '.btn-accordion', function(e) {
      if (!$(e.delegateTarget).hasClass('show')) {
        $('.accordion .item').removeClass('show').find('.accordion-body').slideUp(200);
        $(e.delegateTarget).addClass('show').find('.accordion-body').slideDown(200);
      } else {
        $('.accordion .item').removeClass('show').find('.accordion-body').slideUp(200);
      }
    });

    //Add a class to stick the header on scroll.
    $(window).on('scroll', function(){
      var sticky = $('.nav-fixed');
      var stickOffset = 0;

      if ($('.announcement-bar').length) {
        stickOffset += $('.announcement-bar').outerHeight();
      }

      if ($(this).scrollTop() > stickOffset) {
        sticky.addClass('fixed');
      } else {
        sticky.removeClass('fixed');
      }
    });

    $('body').on('click', 'a[href*="#"]', function(e) {
      var dest = $(this).attr('href');

      //Don't do anything if it's just a generic anchor link
      if (dest != '#' && dest.indexOf('#') !== -1) {
        var destination = document.querySelector(dest);

        if (!destination.classList.contains('popup-form-link')) {
          var hash = dest.split('#')[1];

          if ($('#'+hash).length > 0) {
            e.preventDefault();
            $('html,body').animate({scrollTop: $('#'+hash).offset().top - $('.nav-fixed').height()},'slow');
          }
        }
      }
    });

    $('body').on('click', '.facetwp-page', function() {
      $('html,body').animate({scrollTop: $('.facetwp-template').offset().top - $('.nav-fixed').height() - 100},'slow');
      $('article.animate-in').removeClass('animate-in');
    });

    var $filters = $('.filters, .facetwp-facet');

    if ($filters.length) {
      $(document).on('facetwp-loaded', function() {
        if (FWP.facets['reference_project_locations'] && FWP.facets['reference_project_locations'].length > 0) {
          $('.facet-location').text('in ' + $('.facetwp-facet-reference_project_locations select option:selected').text().replace(/\(.*?\)/g, '').trim());
        } else {
          $('.facet-location').text('');
        }

        if (FWP.facets['reference_project_categories'] && FWP.facets['reference_project_categories'].length > 0) {
          $('.facet-category').text('"' + $('.facetwp-facet-reference_project_categories select option:selected').text().replace(/\(.*?\)/g, '').trim() + '"');
        } else {
          $('.facet-category').text('');
        }

        if (FWP.facets['type'] && FWP.facets['type'].length > 0 && FWP.facets['type'] == 'reference-projects') {
          window.location.replace('https://www.carboncure.com/resourcetype/reference-projects/');
        }

        if (facetsLoaded) {
          gsap.fromTo($('.animate-in'), {
            autoAlpha: 0,
            y: 120,
          }, {
            autoAlpha: 1,
            y: 0,
            ease: 'power3.inOut',
            stagger: 0.2,
            duration: 0.7,
          });

          $('article.animate-in').removeClass('animate-in');
        }

        facetsLoaded = true;
      });

      $(document).on('facetwp-refresh', function() {
        if (!FWP.loaded) {
          let region = window.get_pref(regionCookie);

          console.log(FWP.facets);

          if (region && region != 'global' && Object.hasOwn(FWP.facets, 'region') && FWP.facets['region'] == '') {
            FWP.facets['region'] = [region];
            FWP.fetchData();
            FWP.setHash(); // Optional: update the URL
            // window.location.search = '_region=' + region;
          }
        }
      });
    }

    $('.layout-switcher').on('click', 'button', function() {
      $($(this).data('target')).attr('class', function(i, c){
        return c.replace(/(^|\s)layout-\S+/g, '');
      }).addClass('layout-' + $(this).data('layout'));
      $(this).siblings('button').removeClass('active');
      $(this).addClass('active');
    });

    //Don't let the user submit the header form unless they have entered a value. I would have used HTML5 validation here, but the user can trigger this if they're even trying to open the search box.
    $('.hover-searchform.searchform').on('submit', function(e) {
      if ($('.text-input', $(this)).val() === '') {
        e.preventDefault();
        return false;
      }
    });

    $('.hover-searchform.searchform .searchButton').on('click', function() {
      $('.hover-searchform.searchform .text-input').trigger('focus');
    });

    // CCWidgetUtils
    var $ccWidgets = $('.cc-widget');

    function initializeWidgets() {
      $('.cc-widget').each(function() {
        var $widget = $(this);

        if (ccWidgetUtils.isInViewport($widget) && !$widget.attr('data-loaded')) {
          // console.log('In Viewport Not Loaded');
          $widget.attr('data-loaded', true);

          // console.log(ccWidgetData);

          if (!ccWidgetData) {
            // console.log('No data');
            $.ajax({
              type : 'GET',
              dataType : 'json',
              url: 'https://api.carboncure.com/Public/Counter',
              async: false,
              success: function(data) {
                console.log('Counter API Data', data);

                if(data.hasOwnProperty('all') && data.all && data.hasOwnProperty('sinceYearAgo') && data.sinceYearAgo) {
                  ccWidgetData = data;
                }
              },
              error: function() {
                $widget.closest('.acf-block').hide();
              },
            });
          }

          var widgetTotal = 0;

          if(ccWidgetData && ccWidgetData[$widget.attr('data-api-duration')][$widget.attr('data-api')]) {
            widgetTotal = Number.parseFloat(ccWidgetData[$widget.attr('data-api-duration')][$widget.attr('data-api')]).toFixed(0);
          }

          $widget.attr('data-api-total', widgetTotal);

          ccWidgetUtils.setWidgetTotal($widget);
          ccWidgetUtils.incrementCounter($widget);
        }
      });
    }

    $(window).on('scroll resize', function() {
      initializeWidgets();
    });

    if ($ccWidgets.length) {
      var $unitSwitcher = $('.cc-widget-unit-switcher');

      if ($unitSwitcher.length) {
        $unitSwitcher.find('.toggle').width($unitSwitcher.find('button').outerWidth()).css('left', $unitSwitcher.find('button').position().left);

        $unitSwitcher.find('button').on('click', function() {
          $unitSwitcher.find('.toggle').css('left', $(this).position().left).css('width', $(this).outerWidth());
          $(this).addClass('selected-unit-button').siblings().removeClass('selected-unit-button');

          $('.unit-label').html($(this).attr('data-label'));

          $('.cc-widget').each(function() {
            ccWidgetUtils.setWidgetTotal($(this));
          });
        });
      }

      initializeWidgets();
    }

    var defaultStorepointEmail = 'smacgregor@carboncure.com';

    $('body').on('click', '.storepoint-contact, .contact-request-button', function() {
      var producerSelector = ($(this).hasClass('contact-request-button') ? '> b:first-child' : '.storepoint-name');

      // console.log('Producer Selector', producerSelector);

      var producer = $(this).parent().find(producerSelector).html();

      var producerEmailSelector = ($(this).hasClass('contact-request-button') ? '.storepoint-popup-email:not(.storepoint-popup-website)' : '.producer-email');

      // console.log('Producer Email Selector', producerEmailSelector);

      var producerEmail = $(this).parent().find(producerEmailSelector).html();

      // console.log('Producer', producer);
      // console.log('Producer Email', producerEmail);

      if (!producerEmail) {
        producerEmail = defaultStorepointEmail;
        // console.log('Default Producer Email', producerEmail);
      }

      $.featherlight('/producer-inquiry/?pr=' + encodeURIComponent(producer) + '&pe=' + encodeURIComponent(producerEmail), {
        type: 'iframe',
      });
    });

    var $popup_form_blocks = $('.popup-form-link');

    if ($popup_form_blocks.length) {
      $popup_form_blocks.each(function() {
        var $popup_form = $(this);

        $popup_form.on('click', function(e) {
          e.preventDefault();
        });

        $('[href="#' + $popup_form.attr('id') + '"').on('click', function(e) {
          e.preventDefault();
          $popup_form.trigger('click');
        });
      });
    }

    var $videos = $('iframe[src*="vimeo"], iframe[src*="youtube"]');

    if ($videos.length) {
      $videos.each(function() {
        if (!$(this).parent().hasClass('embed-responsive')) {
          $(this).addClass('embed-responsive-item').wrap('<div class="embed-responsive embed-responsive-16by9"></div>');
        }
      });
    }

    if (document.body.classList.contains('template-form-landing-page')) {
      let scrollContainer = document.querySelector('.scroll-container');

      document.querySelector('.inner-scroll').addEventListener('click', function() {
        scrollContainer.querySelector(this.getAttribute('href')).scrollIntoView({
          behavior: 'smooth',
        });
      });
    }
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js